import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCPgQkxdXKM1GhH6aed11fQAF1lX2vi9zQ",
    authDomain: "sistema-de-gestion-de-vallas.firebaseapp.com",
    projectId: "sistema-de-gestion-de-vallas",
    storageBucket: "sistema-de-gestion-de-vallas.firebasestorage.app",
    messagingSenderId: "972851976118",
    appId: "1:972851976118:web:8b0fd61523c21416ea9317"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
